var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flexbox-container" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "btn-toolbar col-sm-10 offset-sm-1" }, [
        _c("div", { staticClass: "col-sm-6" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary btn-lg btn-block",
              on: {
                click: function($event) {
                  _vm.selectRoute(1)
                }
              }
            },
            [_vm._v("常温商品から登録")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-6" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-success btn-lg  btn-block",
              on: {
                click: function($event) {
                  _vm.selectRoute(2)
                }
              }
            },
            [_vm._v("冷蔵商品から登録")]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48532ba6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48532ba6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/SelectRoute.vue
// module id = null
// module chunks = 